//interfaces
import { IDeleteCommentProps } from  '@/interfaces/activityFeed';

//components
import { CancelConfirmModal} from 'thrive-components';
import DeleteCommentPanel from './DeleteCommentPanel';

//hooks
import UseDeleteComment, {DeleteCommentConstants} from './DeleteComment.hooks';


const DeleteComment = ({showModal, isInlineStyle, onCloseClick, onConfirmClick}: IDeleteCommentProps) => {
    const {handleCancelClick, handleConfirmClick} = UseDeleteComment({showModal, onCloseClick, onConfirmClick});
    const {title, deleteQuestion, cancelButtonText, cancelButtonAriaLabel, confirmButtonText, confirmButtonAriaLabel} = DeleteCommentConstants;
    
    if (!showModal) {
        return <></>
    }
    
    if (isInlineStyle) {
        return (
            <DeleteCommentPanel 
                title={title} 
                cancelButtonText={cancelButtonText} 
                cancelButtonAriaLabel={cancelButtonAriaLabel} 
                confirmButtonAriaLabel={confirmButtonAriaLabel} 
                confirmButtonText={confirmButtonText} 
                handleCancelClick={handleCancelClick} 
                handleConfirmClick={handleConfirmClick}            
            />
        )
    }

    return (
        <CancelConfirmModal 
            headerContent={title} 
            bodyContent={deleteQuestion}
            onCloseClick={onCloseClick}
            cancelButtonText={cancelButtonText}
            cancelButtonAriaLabel={cancelButtonAriaLabel} 
            confirmButtonText={confirmButtonText} 
            confirmButtonAriaLabel={confirmButtonAriaLabel} 
            onCancelClick={onCloseClick} 
            onConfirmClick={onConfirmClick}
        />
    );
};
export default DeleteComment